import React, { useMemo, useState } from 'react';
import '../super-admin.css';
import { mockUsers } from '../mockData';

const ApproveSuspend = () => {
  const [users] = useState(mockUsers);
  const [selected, setSelected] = useState(null);
  const label = useMemo(() => selected ? `${selected.name} <${selected.email}>` : 'None', [selected]);

  const approve = () => {
    if (!selected) return;
    alert(`Approved (demo): ${label}`);
  };
  const suspend = () => {
    if (!selected) return;
    alert(`Suspended (demo): ${label}`);
  };

  return (
    <div className="sa-content">
      <h1>Approve / Suspend Users</h1>
      <div className="section">
        <p>Select a user to approve or suspend.</p>
        <div>
          <select value={selected?.id || ''} onChange={(e) => setSelected(users.find(u => u.id === Number(e.target.value)) || null)}>
            <option value="">-- choose user --</option>
            {users.map(u => <option key={u.id} value={u.id}>{u.name} ({u.email})</option>)}
          </select>
          <div style={{ marginTop: 8 }}>Selected: <strong>{label}</strong></div>
        </div>
        <div style={{ marginTop: 12 }}>
          <button onClick={approve} disabled={!selected}>Approve</button>
          <button style={{marginLeft:8}} onClick={suspend} disabled={!selected}>Suspend</button>
        </div>
      </div>
    </div>
  );
};

export default ApproveSuspend;
